export const DEFAULT_FIELDS = ["source", "destination_ip", "usernames"];
export const getStreamFavoriteFields = (stream, fields = {}) => {
  var _a;
  return (_a = stream == null ? void 0 : stream.favorite_fields) != null ? _a : DEFAULT_FIELDS.filter((field) => Object.hasOwn(fields, field));
};
